import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import LivePage from './pages/LivePage'
import './styles.css'

createRoot(document.getElementById('root')!).render(<StrictMode><LivePage /></StrictMode>)
